import { createFileRoute } from "@tanstack/react-router";
import OrdersScreen from "../Screens/Orders";

export const Route = createFileRoute("/orders")({
  component: RouteComponent,
});

function RouteComponent() {
  return (
    <>
      <OrdersScreen />
    </>
  );
}
